import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=218f785f&scoped=true&"
import script from "./CtaButton.vue?vue&type=script&lang=js&"
export * from "./CtaButton.vue?vue&type=script&lang=js&"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=218f785f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f785f",
  null
  
)

export default component.exports